<template>
    <v-layout justify-center>
        <v-responsive max-width="480" width="100%" height="100%" class="px-3 mx-n3 d-flex flex-column">
            <list-heading title="채팅상담 상담내역 상세" />

            <v-card outlined style="overflow: hidden">
                <vertical-table v-bind="{ items }" style="margin: -1px 0" />
            </v-card>
            <div class="mt-3" style="max-height: calc(100vh - 48px - 12px - 56px - 136px - 12px - 12px); overflow: hidden">
                <chat-room-view-messages v-bind="{ messages }" />
            </div>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import { initChatRoom } from "@/store/chat";

import ListHeading from "@/components/console/dumb/list-heading.vue";
import VerticalTable from "@/components/console/dumb/vertical-table.vue";
import ChatRoomViewMessages from "@/components/console/chat/rooms/view/chat-room-view-messages.vue";

export default {
    components: {
        ListHeading,
        VerticalTable,
        ChatRoomViewMessages,
    },
    props: {
        _room: { type: String, default: null },
    },
    data: () => ({
        room: initChatRoom(),

        loading: false,
    }),
    computed: {
        items() {
            let { owner = {} } = this.room;
            if (owner?.user) {
                owner = `${owner?.user?.name} (${owner?.user?.username})`;
            } else {
                owner = `비회원 (${owner?.sessionId})`;
            }

            return [
                {
                    term: "사용자",
                    data: owner,
                },
                {
                    term: "생성일시",
                    data: this.room?.createdAt?.toDateTime?.(),
                },
                {
                    term: "갱신일시",
                    data: this.room?.updatedAt?.toDateTime?.(),
                },
            ].map(function mapItem(item) {
                if (Array.isArray(item)) {
                    return item.map(mapItem);
                } else {
                    return {
                        ...item,
                        divider: true,
                        props: {
                            rowProps: {
                                class: "text-caption",
                            },
                            termProps: {
                                cols: 12,
                                md: 3 * (12 / (item.cols ?? 12)),
                            },
                        },
                    };
                }
            });
        },
        messages() {
            return this.room.messages || [];
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        async init() {
            try {
                this.search();
            } catch (error) {
                console.error(error);
            }
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { room } = await api.console.chat.rooms.get({
                    _id: this._room,
                });

                this.room = room;
            } finally {
                if (this.loading) this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
